import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { TablePerfilesDataSource, TablePerfilesItem } from './table-perfiles-datasource';

@Component({
  selector: 'app-table-perfiles',
  templateUrl: './table-perfiles.component.html',
  styleUrls: ['./table-perfiles.component.scss']
})
export class TablePerfilesComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<TablePerfilesItem>;
  dataSource: TablePerfilesDataSource;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['descripcion', 'activo', 'accion'];

  ngOnInit() {
    this.dataSource = new TablePerfilesDataSource();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.table.dataSource = this.dataSource;
  }

  ejecutarFuncion(funcion = '') {
    alert('Thanks');
  }
}


